import { React, useState, useEffect, useRef, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import Notfound from './NotFound';
import { Helmet } from 'react-helmet';
import '../../App.css';
import config from './config';
import ReactGA from 'react-ga4';
//import { MY_CONSTANT } from "../../constants"

const ProductDetail = () => {

    //   const token = MY_CONSTANT.token;
    const [price, setprice] = useState(2500);
    const [ship_price, setship_price] = useState(600);
    const [qty, setqty] = useState(1);
    const [pricetotal, setpricetotal] = useState(0);
    const [sumr, setsumr] = useState(true);
    const [selected, setSelected] = useState(0);
    const [shipmethod, setshipmethod] = useState(0);
    const [defimg, setdefimg] = useState('');
    const [listimg, setlistimg] = useState([]);
    // eslint-disable-next-line 
    // const currentdomain = window.location.origin.split(':3000')[0];
    const [name, setname] = useState('');
    const [phone, setphone] = useState('');
    const [titla, settitla] = useState('');
    const [wilaya, setwilaya] = useState('');
    const [adress, setadress] = useState('');
    const [pixel, setpixel] = useState('999');
    const [disablebt, setdisablebt] = useState(false);
    const [isfirst, setisfirst] = useState(true);
    const urla = `${config.host_backend}/products/prod_id/`;
    let index_wilaya = parseInt((selected.toString().replace(/[^0-9]/g, ''))) - 1;
    // const urla = 'https://react.osrati.shop/bk/get_all.php?id=';
    //const urla = 'http://127.0.0.1/bk/get_all.php?id=';
    const navigate = useNavigate();
    const randomNumberInRange = (min, max) => {
        return Math.floor(Math.random()
            * (max - min + 1)) + min;
    };

    const [isDesktop, setIsDesktop] = useState(false);

    const checkDevice = () => {
        setIsDesktop(window.innerWidth > 1024); // You can adjust the breakpoint as needed
    };


    // const prod_id = new URLSearchParams(window.location.search).get('id');
    // const [prod_id, setprod_id] = useState(null);

    const [datas, setdatas] = useState([]);

    const [delvprice, sedelvprice] = useState([]);
    const [ishidden, setishidden] = useState(false);
    //const [loading, setLoading] = useState(true);

    const [activeKey, setActiveKey] = useState(null);
    const [prod_ids, setprod_ids] = useState(null);

    const handleactivimg = (key) => {
        setActiveKey(activeKey === key ? null : key);
    };
    //var referrer = document.referrer;

    const isActive = (key) => activeKey === key;
    const [isScrollingAllowed, setIsScrollingAllowed] = useState(true);


    const paths = window
        .location
        .pathname
        .split("/")
        .filter(path => path !== "");
    const prod_id = paths[paths.length - 1];


    useEffect(

        function () {
            checkDevice();
            async function fetchData() {

                try {

                    const response = await fetch(urla, {

                        method: 'POST',
                        headers: {
                            // 'Content-Type': 'text/html',
                            'Content-Type': 'application/json',
                            'Access-Control-Allow-Origin': '*',

                        },
                        //  mode: 'cors',
                        body: JSON.stringify({ prod_id }),
                    });

                    if (!response.ok) {
                        throw new Error('Network response was not ok');

                    }
                    const data = await response.json();
                    if (data === null) {
                        navigate('/not_found', { replace: true })
                        // console.log('nullllllll')
                    }
                    else {

                        if (data.success === 1) {
                            setishidden(false)
                            setdatas((data.datas)[0].products[0]);
                            sedelvprice((data.datas)[1].delevery);
                        }
                        else if (data.success === 0) {
                            setishidden(true)
                        }
                    }

                } catch (error) {
                    console.log('errrrrrrrrrrrrrrrrrrrr');
                    console.error('Error fetching data:', error);

                }

            }
            if (prod_id === 'product') {
                navigate('/not_found', { replace: true });
            }
            else {
                //  setprod_id(pathName)
                fetchData();

            }
            // eslint-disable-next-line 
        }, []
    );


    useEffect(
        function () {
            setpixel(datas.pixel_data);
            setdefimg(datas.img_default);
            settitla((datas.product_name + "").substring(0, 30));
            setprice(datas.price);
            setlistimg((datas.imgs + "").split(','));
            setprod_ids(datas.product_id);
            (parseInt(datas.hidden) === 1) && setishidden(true);
        }, [datas]

    );


    useEffect(
        function () {

            // console.log(delvprice.delevery);
            if (selected !== 0) {
                setship_price(((shipmethod === '1') ? parseInt(delvprice[index_wilaya].desktop_price) : parseInt(delvprice[index_wilaya].house_price)))
            }
            //  setship_price((shipmethod === 1) ? 500:1000);
            setpricetotal(ship_price + (price * qty));
        }, [selected, qty, shipmethod, ship_price, delvprice, index_wilaya, price]
    );

    const handleChange = event => {
        setSelected((event.target.value));
        setwilaya((event.target.value));
    };
    const handleChangeShip = event => {
        setshipmethod((event.target.value));
    };
    function handleNext() {
        setqty(qty + 1);
    }
    function handlePrev() {
        (qty > 1) ? setqty(qty - 1) : setqty(1);
    }
    function showsumr() {
        setsumr(!sumr);
        //  alert("change");
    }


    //------------------------------------ POST DATA TO BACK END-----------------------------------

    /*  const [formData, setFormData] = useState({
          name: '',
          phone: '',
          //state: '',
          adress: ''
      });*/

    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);


    const ordera = {
        "id": randomNumberInRange(100, 1000000),
        "province_id": parseInt(index_wilaya + 1),
        "product_id": prod_ids,
        "client_name": name,
        "phone": phone,
        "selling_price": price,
        "selling_ship_price": ship_price,
        "address": adress,
        "quantity": qty,
        "shiping_desktop": shipmethod,
        "wilaya": wilaya,
        "product": titla
        // "delvry_price": ship_price,
    }


    function reset_filled() {
        localStorage.setItem('title', titla);
        localStorage.setItem('price', price);
        localStorage.setItem('ship_price', ship_price);
        localStorage.setItem('qty', qty);
        setname('');
        setphone('');
        setwilaya('');
        setadress('');

    }

    function check_empty() {
        return (((name && phone) === '') || selected === 0);
    }


    // const handleSubmit = async (e) => {
    // e.preventDefault();

    // const handleSubmit = async () => {
    async function handleSubmit() {

        ReactGA.event({
            category: 'BUY',
            action: 'first Clicked Buy',
            label: 'Buy Now',
        });
        const timeout = 25000; // Set your desired timeout in milliseconds

        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), timeout);
        try {

            if (!check_empty()) {
                setdisablebt(true);
                setError(null);
                setSuccess(null);
                const response = await fetch(`${config.host_backend}/orders/add_order/`, {

                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': '*',
                        // 'Authorization': `Bearer ${token}`,
                    },
                    body: JSON.stringify(ordera),
                    signal: controller.signal,
                }).finally(() => clearTimeout(timeoutId));
                if ((!response.ok) || (response.success === 0)) {
                    ReactGA.event({
                        category: 'Buy',
                        action: 'Clicked Buy failed',
                        label: 'Buy Now',
                    });
                    setdisablebt(false);
                    setSuccess(null);
                    setError('فشل تسجيل الطلب ارجو  اعادة ارسال الطلب');
                    throw new Error('Network response was not ok');

                }
                ReactGA.event({
                    category: 'Buy',
                    action: 'Clicked Buy successfully',
                    label: 'Buy Now',
                });

                // setSuccess('Data sent successfully!');
                reset_filled();
                setError(null);
                setdisablebt(false);
                navigate('/thank_page', { replace: true });
            }
            else { setError('يرجا منكم كتابة جميع معلومات لاتمام الطلب'); }

        } catch (error) {
            setError('فشل تسجيل الطلب ارجو  اعادة ارسال الطلب');
            setSuccess(null);
            setdisablebt(false);

        }


    }





    document.title = datas.product_name;
    const handleScroll = () => {
        // Find the target element by its ID
        const targetElement = document.getElementById('form');

        // Scroll to the target element
        if (targetElement) {
            targetElement.scrollIntoView({ behavior: 'smooth' });
        }
    };
    //***************scroll listner element */
    const ref1 = useRef(null);
    const ref2 = useRef(null);
    const leftContentRef = useRef(null);
    const isInViewport1 = useIsInViewport(ref1);
    const isInViewport2 = useIsInViewport(ref2);

    const handleScroll_right_content = (e) => {
        if (window.innerWidth >= 1024) {
            e.preventDefault(); // Prevent default scrolling on the right content
            if (leftContentRef.current) {
                const newScrollTop = leftContentRef.current.scrollTop + e.deltaY;

                // Check if the new scroll position is within bounds
                const isAtTop = newScrollTop <= 0;
                const isAtBottom = newScrollTop >= leftContentRef.current.scrollHeight - leftContentRef.current.clientHeight;

                // Only allow scrolling if not at the top or bottom
                if (!isAtTop && !isAtBottom) {
                    leftContentRef.current.scrollTo({
                        top: newScrollTop,
                        behavior: 'smooth',
                    });
                }

                // Prevent main page scrolling when at the bounds
                setIsScrollingAllowed(!isAtBottom);
            }
        }
    };



    function useIsInViewport(ref) {
        const [isIntersecting, setIsIntersecting] = useState(false);

        const observer = useMemo(
            () =>
                new IntersectionObserver(([entry]) =>
                    setIsIntersecting(entry.isIntersecting),
                ),
            [],
        );

        useEffect(() => {
            observer.observe(ref.current);

            return () => {

                observer.disconnect();
            };
        }, [ref, observer]);

        return isIntersecting;
    }
    //**********************************************************

    // useEffect(() => {
    //     const handleWheel = (e) => {
    //         if (!isScrollingAllowed) {
    //             e.preventDefault();
    //         }
    //     };

    //     window.addEventListener('wheel', handleWheel, { passive: false });

    //     return () => {
    //         window.removeEventListener('wheel', handleWheel);
    //     };
    // }, [isScrollingAllowed]);
    useEffect(() => {
        const handleWheel = (e) => {
            if (!isScrollingAllowed) {
                e.preventDefault();
            }
        };

        // Only add wheel listener for larger screens
        const handleResize = () => {
            if (window.innerWidth >= 1024) {
                window.addEventListener('wheel', handleWheel, { passive: false });
            } else {
                window.removeEventListener('wheel', handleWheel);
            }
        };

        handleResize(); // Check size on component mount

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('wheel', handleWheel);
        };
    }, [isScrollingAllowed]);

    return (
        <>

            <Helmet>
                {/* Facebook Meta Tags */}

                <meta property="og:title" content={datas.product_name} />
                <meta property="og:description" content={pixel} />
                <meta property="og:image" content={datas.img_default} />
                <meta property="og:url" content={window.location.href} />
                <meta property="og:type" content="website" />


                {pixel}



            </Helmet>

            <div>

                {
                    (ishidden) ? <Notfound /> :
                        <div className='container w-full   mx-auto  border '>


                            <div className='spliter grid grid-cols-1 lgg:grid-cols-2 gap-1 mt-3 mb-11 content-center '>

                                {/* <div className="lgg:flex lgg:justify-start lgg:items-start pb-11">
                                    <div className="lgg:fixed   bg-white shadow-lg  rounded-lg"> */}

                                <div ref={ref2} className={`prodimg  border-solid border-2 border-gray-200 m-1 h-15 rounded-lg   ${(isDesktop) ? 'lgs:sticky' : ''}    lgs:top-0 lgs:h-auto`}
                                    onWheel={handleScroll_right_content}>
                                    <ul>
                                        <li>

                                            <div style={{ '--image-url': `url(${defimg})` }} className="h-96 w-72 mdd:w-96 items-center    mx-auto  bg-cover  bg-center bg-no-repeat bg-[image:var(--image-url)] ">
                                                <div className="w-full h-fit flex  justify-end items-start lgg:hidden " >
                                                    <span className='orderbt    bg-green-600  text-white font-bold text-xs mdd:text-lg rounded-sm   h-18   '>تخفيض!</span>
                                                </div>
                                            </div>


                                        </li>
                                        <li className='minature flex justify-center'>
                                            <div className={`smalimgs grid grid-cols-${listimg.length}  mb-3 ms-3  mt-11 text-center gap-2`}>
                                                {listimg.map((element, index) => (
                                                    // eslint-disable-next-line
                                                    <div key={index} onClick={() => (setdefimg(element), handleactivimg(index), setisfirst(false))} style={{ '--image-url': `url(${element})` }} className={`border-solid rounded-lg border-2  ${(isActive(index) || (listimg.length === 1) || ((index === 0) && (isfirst))) ? 'border border-green-400' : 'border-gray-300'} hover:border-green-400 active:border-green-400 h-11 w-11 mds:h-20 mds:w-20 mdd:h-24 mdd:w-24 cursor-pointer bg-cover  bg-center bg-no-repeat bg-[image:var(--image-url)]`} />
                                                ))}
                                            </div>
                                        </li>
                                    </ul>





                                </div>

                                <div ref={leftContentRef} className='overflow-y-scroll h-screen   lgs:h-auto lgs:overflow-auto scrollbar-hide'
                                >
                                    <div className='headprice ms-4'>
                                        {/* <div className='prodtitle font-bold text-3xl text-start'> سماعة لاسلكية ذكية</div> */}
                                        <div id="form" className='prodtitle font-bold text-3xl text-start'>{datas.product_name}</div>

                                        <div className='subprice font-semibold text-xl flex justify-start items-center gap-3'>
                                            <span className='prices text-green-500 font-bold text-2xl'>
                                                {datas.price}  دج
                                            </span>
                                            <span className='oldprices text-gray-500 line-through'>
                                                {datas.oldprice} دج
                                            </span>
                                            <span className='discount text-sm bg-green-600 text-white'>
                                                خصم {(((datas.oldprice - datas.price) / datas.oldprice) * 100).toFixed(0)}%
                                            </span>
                                        </div>

                                        <div className="flex items-center">
                                            <svg className="w-4 h-4 text-yellow-300 ms-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                                                <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
                                            </svg>
                                            <svg className="w-4 h-4 text-yellow-300 ms-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                                                <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
                                            </svg>
                                            <svg className="w-4 h-4 text-yellow-300 ms-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                                                <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
                                            </svg>
                                            <svg className="w-4 h-4 text-yellow-300 ms-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                                                <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
                                            </svg>
                                            <svg className="w-4 h-4 ms-1 text-yellow-300" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                                                <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
                                            </svg>
                                        </div>

                                    </div>
                                    <div className="leftcontener m-3 border-solid border-2 border-gray-200 bg-gray-50 p-2 rounded-xl">
                                        <div ref={ref1} className='bordrform '>
                                            <div className='formtitle text-center'>
                                                <h3>للطلب أدخل معلوماتك في الخانات أسفله 👇</h3>
                                                {success && <p style={{ color: 'green' }}>{success}</p>}
                                                {error && <p className="animate-bounce mt-3 text-red-600 text-lg">{error}</p>}
                                            </div>
                                            <form className="orderform  rounded-xl mb-2 mt-2  px-1 py-1 grid grid-cols-1 mds:grid-cols-2 gap-1 content-center" method="POST" action=''>
                                                <input id="exampleFormControlInput1" name="name" onChange={(event) => setname(event.target.value)} value={name} className="name p-2 mt-2 border-solid border-2 border-gray-200 focus:border-green-600 focus:outline-none font-semibold text-lg rounded-lg" type="text" placeholder="الاسم بالكامل 🤵‍♂️" required autoComplete="off" />

                                                <input name="phone" onChange={(event) => setphone(event.target.value)} value={phone} className="name p-2 mt-2 border-solid border-2 border-gray-200 focus:border-green-600 focus:outline-none text-right font-semibold text-lg rounded-lg" type="tel" placeholder="رقم الهاتف 📞" pattern="^(06|07|05)[0-9]{8}$" required autoComplete="off" />

                                                <select name="state" defaultValue={'jjj'} onChange={handleChange} className="wilaya  text-black p-2 mt-2 border-solid border-2  border-gray-200 focus:border-green-600 focus:outline-none font-semibold text-lg bg-gray-50 rounded-lg" id='judecheckout_state' required >
                                                    <option value="jjj" disabled >   الولاية 👇</option>
                                                    <option id='judecheckout_state_click'>01 Adrar - أدرار</option><option id='judecheckout_state_click'>02 Chlef - الشلف</option><option id='judecheckout_state_click'>03 Laghouat - الأغواط</option><option id='judecheckout_state_click'>04 Oum El Bouaghi - أم البواقي</option><option id='judecheckout_state_click'>05 Batna - باتنة</option><option id='judecheckout_state_click'>06 Béjaïa - بجاية</option><option id='judecheckout_state_click'>07 Biskra - بسكرة</option><option id='judecheckout_state_click'>08 Bechar - بشار</option><option id='judecheckout_state_click'>09 Blida - البليدة</option><option id='judecheckout_state_click'>10 Bouira - البويرة</option><option id='judecheckout_state_click'>11 Tamanrasset - تمنراست </option><option id='judecheckout_state_click'>12 Tébessa - تبسة </option><option id='judecheckout_state_click'>13 Tlemcene - تلمسان</option><option id='judecheckout_state_click'>14 Tiaret - تيارت</option><option id='judecheckout_state_click'>15 Tizi Ouzou - تيزي وزو</option><option id='judecheckout_state_click'>16 Alger - الجزائر</option><option id='judecheckout_state_click'>17 Djelfa - الجلفة</option><option id='judecheckout_state_click'>18 Jijel - جيجل</option><option id='judecheckout_state_click'>19 Sétif - سطيف</option><option id='judecheckout_state_click'>20 Saïda - سعيدة</option><option id='judecheckout_state_click'>21 Skikda - سكيكدة</option><option id='judecheckout_state_click'>22 Sidi Bel Abbès - سيدي بلعباس</option><option id='judecheckout_state_click'>23 Annaba - عنابة</option><option id='judecheckout_state_click'>24 Guelma - قالمة</option><option id='judecheckout_state_click'>25 Constantine - قسنطينة</option><option id='judecheckout_state_click'>26 Médéa - المدية</option><option id='judecheckout_state_click'>27 Mostaganem - مستغانم</option><option id='judecheckout_state_click'>28 MSila - مسيلة</option><option id='judecheckout_state_click'>29 Mascara - معسكر</option><option id='judecheckout_state_click'>30 Ouargla - ورقلة</option><option id='judecheckout_state_click'>31 Oran - وهران</option><option id='judecheckout_state_click'>32 El Bayadh - البيض</option><option id='judecheckout_state_click'>33 Illizi - إليزي </option><option id='judecheckout_state_click'>34 Bordj Bou Arreridj - برج بوعريريج</option><option id='judecheckout_state_click'>35 Boumerdès - بومرداس</option><option id='judecheckout_state_click'>36 El Tarf - الطارف</option><option id='judecheckout_state_click'>37 Tindouf - تندوف</option><option id='judecheckout_state_click'>38 Tissemsilt - تيسمسيلت</option><option id='judecheckout_state_click'>39 Eloued - الوادي</option><option id='judecheckout_state_click'>40 Khenchela - خنشلة</option><option id='judecheckout_state_click'>41 Souk Ahras - سوق أهراس</option><option id='judecheckout_state_click'>42 Tipaza - تيبازة</option><option id='judecheckout_state_click'>43 Mila - ميلة</option><option id='judecheckout_state_click'>44 Aïn Defla - عين الدفلى</option><option id='judecheckout_state_click'>45 Naâma - النعامة</option><option id='judecheckout_state_click'>46 Aïn Témouchent - عين تموشنت</option><option id='judecheckout_state_click'>47 Ghardaïa - غرداية</option><option id='judecheckout_state_click'>48 Relizane- غليزان</option><option id='judecheckout_state_click'>49 Timimoun - تيميمون</option><option id='judecheckout_state_click'>50 Bordj Baji Mokhtar - برج باجي مختار</option><option id='judecheckout_state_click'>51 Ouled Djellal - أولاد جلال</option><option id='judecheckout_state_click'>52 Béni Abbès -  بني عباس</option><option id='judecheckout_state_click'>53 Aïn Salah - عين صالح</option><option id='judecheckout_state_click'>54 In Guezzam - عين قزام</option><option id='judecheckout_state_click'>55 Touggourt - تقرت</option><option id='judecheckout_state_click'>56 Djanet - جانت</option><option id='judecheckout_state_click'>57 El MGhair - المغير</option><option id='judecheckout_state_click'>58 El Menia - المنيعة</option>
                                                </select>


                                                <input name="adress" onChange={(event) => setadress(event.target.value)} className="name p-2 mt-2 border-solid border-2 border-gray-200 focus:border-green-600 focus:outline-none font-semibold text-lg  rounded-lg" type="text" placeholder="البلدية و العنوان الكامل 📍" required autoComplete="off" />
                                                <select name="state" defaultValue={'0'} onChange={handleChangeShip} className="name mds:col-span-2 p-2 mt-2 border-solid border-2  border-gray-200  focus:outline-none font-semibold text-lg rounded-lg bg-gray-50" id='judecheckout_state' required >
                                                    <option value="0">التوصيل الى باب المنزل</option>
                                                    <option value="1">التوصيل الى مكتب شركة التوصيل</option>
                                                </select>

                                            </form>

                                            <div className='qtyorder grid grid-cols-4 gap-1 w-full '>


                                                <div className="form-qte   flex justify-start ms-1   w-full">
                                                    <input type='button' value='+' onClick={handleNext} className='qtyplus active:bg-green-200  h-10  w-14 border-solid border-2 border-gray-200 hover:cursor-pointer' field='quantity' />
                                                    <input type='button' name='quantity' value={qty} className='qty   text-center h-10  w-16 border-solid border-y-2 border-gray-200' />
                                                    <input type='button' onClick={handlePrev} value='-' className='qtyminus active:bg-green-200  h-10  w-14 border-solid border-2 border-gray-200 hover:cursor-pointer' field='quantity' />


                                                </div>
                                                <div className={` ${(disablebt) ? 'bg-gray-400' : 'bg-green-600'} orderbt   col-span-3 flex justify-center  mr-1  text-white font-bold text-xl rounded-xl   h-11 active:bg-yellow-400 hover:cursor-pointer`} onClick={((!disablebt) ? () => handleSubmit() : console.log('btn dissssss'))}>
                                                    <button id="nrwooconfirm" type="submit" name="judecheckout-submit" form="judecheckout_woo_single_form" className='hover:cursor-pointer' >{disablebt ? 'جاري تلقي طلبك ...' : 'تأكيد الطلب'}</button>
                                                    <div className={`mt-2 ms-3 ${(!disablebt) ? 'hidden' : ''}`}>
                                                        <svg aria-hidden="true" className="inline w-7 h-7 text-white animate-spin  fill-red-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                                                            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                                                        </svg>
                                                    </div>
                                                </div>

                                            </div>

                                        </div>

                                        {/* order summer ----------------------------------------------------------------------------------------------------- */}


                                        <div className="ordersum px-3 py-2 " >
                                            <div id="judecheckout_order_history" className="clear flex justify-between  hover:cursor-pointer " onClick={showsumr}>

                                                <div id="judecheckout_h_right" className="flex  font-normal text-lg items-stretch">
                                                    <span id="judecheckout_h_o" >
                                                        <i className='bx bxs-cart bx-sm' />
                                                    </span>
                                                    <span>
                                                        ملخص الطلب
                                                    </span>

                                                </div>

                                                <div className='mt-1'>
                                                    <i className={`bx bx-chevron-up bx-sm ${sumr ? '' : 'rotate-180'}  `} />
                                                    {/* {sumr ?
                                                        <i className={'bx bx-chevron-up bx-sm'} />
                                                        : <i className='bx bx-chevron-down bx-sm ' />
                                                    } */}
                                                </div>

                                            </div>
                                            <div className='space w-auto h-1   border-solid border-2 border-gray-200' />




                                            <div id="judecheckout_show_hide" className={sumr ? "judecheckout_show_hide mt-3 " : "hidden"}>

                                                <div className='tabla' >


                                                    <div className='flex justify-between ' >
                                                        <div className="summary-product-title font-bold line-clamp-1 ">{titla}</div>
                                                        <div className='pe-6'>

                                                            <span id="judecheckout_v_price" className=''>{price}</span>
                                                            <span className='bg-green-600   me-4   '>
                                                                <span id="judecheckout_v_price" className=' text-white font-bold  text-xs me-0.5'>x</span>
                                                                <span id="judecheckout_count_number" className='judecheckout_count_number font-bold  text-white text-xs ms-0.5 '>  {qty}</span>
                                                            </span>


                                                            <span> &#x62f;.&#x62c;</span>

                                                        </div>
                                                    </div>
                                                    <div className="border-dashed mb-1 border-t-2 border-gray-50 bg-gray-300  inline-block w-full" />
                                                    <div className='flex justify-between '>
                                                        <div>
                                                            <span>
                                                                سعر التوصيل                    </span>
                                                            <div id="shipping-methods"></div>

                                                        </div>
                                                        <div id="judecheckout_d_has_price" className='pe-7' >
                                                            <span id="judecheckout_d_price">
                                                                <span className="summary-select-state">
                                                                    {selected === 0 ? ' إختر الولاية 👇' : ship_price}
                                                                </span>
                                                            </span>
                                                            <span className={selected === 0 ? "hidden" : "judecheckout_currency"}> &#x62f;.&#x62c;                    </span>
                                                        </div>
                                                        {/* <div id="judecheckout_d_free" style="display:none;"><span>مجانا</span></div> */}

                                                    </div>
                                                    <div className="border-dashed  border-t-2 border-gray-50 bg-gray-300  inline-block w-full" />
                                                    <div className="full-price flex justify-between mb-1">
                                                        <div className='font-bold'>السعر الإجمالي</div>
                                                        <div className='pe-3  font-semibold text-xl'  ><span id="judecheckout_total_price">{selected === 0 ? '' : pricetotal}</span> <span className='  font-semibold'>{selected === 0 ? '' : 'دج'} </span></div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>


                                    </div>







                                    <div className='discript ms-5 mb-24 mt-6'>
                                        <div dangerouslySetInnerHTML={{ __html: datas.description }} />
                                    </div>
                                    {/* <div className='short_discript'>
                                        <div dangerouslySetInnerHTML={{ __html: datas.short_dicrp }} />
                                    </div> */}
                                </div>


                            </div>


                            {/* <div className="overlay-layout mb-6 mx-3 fixed inset-x-0 bottom-0 bg-black bg-opacity-50 text-white z-20 flex justify-center items-center h-11"> */}
                            <div className={(isInViewport1 || isInViewport2) ? "hidden" : "overlay-layout  smm:hidden   mb-8 mx-5 fixed inset-x-0 bottom-0 bg-gray-400 bg-opacity-0 text-black z-20 flex justify-center items-center h-14"}>

                                <button className="gohome animate-bounce w-60  p-2 bg-green-600  text-white font-bold text-lg  mdd:text-lg rounded-sm   h-11 mdd:h-11  hover:cursor-pointer" onClick={handleScroll}>للطلب اضغط هنا</button>

                            </div>
                        </div >
                }
            </div>

        </>

    )

}

export default ProductDetail;